import styled from 'styled-components';

export const Container = styled.div<{ error?: boolean }>`
	display: grid;
	grid-template-columns: 1fr;
	grid-gap: ${({ error }) => (error ? '18px' : '20px')};
	place-items: center;
	margin-top: 30px;

	div {
		width: 100%;
	}

	.password {
		& > button {
			top: 20px;
		}
	}

	h3 {
		margin-bottom: 20px;
		font-style: normal;
		font-weight: 500;
		font-size: 16px;
		line-height: 22px;
		display: flex;
		align-items: center;
		text-align: center;
		color: #5082c2;
	}
`;

export const ErrorField = styled.div`
	font-size: 12px;
	color: tomato;
`;
